import React, { useState, cloneElement } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Badge from '@material-ui/core/Badge';

import DeleteIcon from '@material-ui/icons/Delete';
import FilterIcon from 'app/components/icons/Filter';
import FilterListIcon from '@material-ui/icons/FilterList';
import ExportIcon from '@material-ui/icons/CloudDownload';
import PrintIcon from '@material-ui/icons/Print';
import PaymentIcon from '@material-ui/icons/MoneyOff';
import RefundIcon from '@material-ui/icons/Replay';
import AddIcon from '@material-ui/icons/Add';
import ImportIcon from '@material-ui/icons/CloudUpload';
import EmailIcon from '@material-ui/icons/Email';
import RefreshIcon from '@material-ui/icons/Refresh';

import TableColumns from 'app/components/tables/TableColumns';
import { lighten } from '@material-ui/core/styles/colorManipulator';

const useToolbarStyles = makeStyles(theme => ({
    root: {
        paddingRight: theme.spacing(1),
    },
    highlight: theme.palette.type === 'light' ? {
        color: theme.palette.primary.main,
        backgroundColor: lighten(theme.palette.primary.light, 0.85),
    } : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.primary.dark,
    },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.primary,
    },
    title: {
        flex: '0 0 auto',
    },
    searchContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    search: {
        position: 'relative',
        display: 'flex',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.grey[100],
        '&:hover': {
            backgroundColor: theme.palette.grey[200],
        },
        '&:focus': {
            backgroundColor: theme.palette.grey[200],
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(3),
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing(1) * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },
    button: {
        margin: theme.spacing(1),
    },
}));

export default function TableToolbar(props) {

    const classes = useToolbarStyles();

    const {
        columns,
        newUrl,
        searchColumn,
        onSearchColumnChange,
        searchValue,
        onSearchValueChange,
        onSearch,
        onDeleteSelected,
        onImport,
        data,
        selected,
        viewableColumns,
        onToggleColumn,
        onToggleAllColumns,
        onExportSelected,
        onExportAll,
        label,
        RefundDialog,
        PaymentDialog,
        FilterDialog,
        NewDialog,
        EmailDialog,
        onFilter,
        filterCount,
        getTable
    } = props;

    const numSelected = selected ? selected.length : 0;

    const [ columnsDialogOpen, setColumnsDialogOpen ] = useState(false);
    const [ newDialogOpen, setNewDialogOpen ] = useState(false);
    const [ filterDialogOpen, setFilterDialogOpen ] = useState(false);
    const [ emailDialogOpen, setEmailDialogOpen ] = useState(false);
    const [ paymentDialogOpen, setPaymentDialogOpen ] = useState(false);
    const [ refundDialogOpen, setRefundDialogOpen ] = useState(false);

    const handleSearch = (event, bypass = false) => {
        if (bypass || (event.key && event.key === 'Enter')) {
            onSearch();
        }
    }

    // New Dialog

    const openNewDialog = () => {
        setNewDialogOpen(true);
    }

    const closeNewDialog = () => {
        setNewDialogOpen(false);
    }

    const closeNewDialogAndRefresh = () => {
        closeNewDialog();
        getTable();
    }

    // Filter Dialog

    const openFilterDialog = () => {
        setFilterDialogOpen(true);
    }

    const closeFilterDialog = () => {
        setFilterDialogOpen(false);
    }

    // Email Dialog

    const openEmailDialog = () => {
        setEmailDialogOpen(true);
    }

    const closeEmailDialog = () => {
        setEmailDialogOpen(false);
    }

    // table columns

    const openColumnsDialog = () => {
        setColumnsDialogOpen(true);
    }

    const closeColumnsDialog = () => {
        setColumnsDialogOpen(false);
    }

    // table columns

    const openRefundDialog = () => {
        setRefundDialogOpen(true);
    }

    const closeRefundDialog = () => {
        setRefundDialogOpen(false);
    }

    const closeRefundDialogAndRefresh = () => {
        closeRefundDialog();
        getTable();
    }

    // table columns

    const openPaymentDialog = () => {
        setPaymentDialogOpen(true);
    }

    const closePaymentDialog = () => {
        setPaymentDialogOpen(false);
    }

    const closePaymentDialogAndRefresh = () => {
        closePaymentDialog();
        getTable();
    }

    // Multiple select options

    const deleteItems = () => {
        onDeleteSelected();
    }

    const exportItems = () => {
        onExportSelected();
    }

    const exportAll = () => {
        onExportAll();
    }

    const print = () => {

        var content = document.getElementById("paginated-table-wrapper");
        var pri = document.getElementById("tablecontentstoprint").contentWindow;

        pri.document.open();
        pri.document.write(content.innerHTML);

        var styles = document.querySelectorAll('style');

        for(var i = 0; i < styles.length; i++)
        {
            pri.document.head.appendChild(styles[i].cloneNode(true));
        }

        pri.document.close();
        pri.focus();
        pri.print();
    }

    const NewDialogCloned = NewDialog ? cloneElement(
        NewDialog,
        { open: newDialogOpen, onClose: closeNewDialog, onSave: closeNewDialogAndRefresh }
    ) : null;

    const FilterDialogCloned = FilterDialog ? cloneElement(
        FilterDialog,
        { open: filterDialogOpen, onClose: closeFilterDialog, onFilter: onFilter }
    ) : null;

    const EmailDialogCloned = EmailDialog ? cloneElement(
        EmailDialog,
        { open: emailDialogOpen, onClose: closeEmailDialog, onSave: closeEmailDialog, ids: selected, data: data }
    ) : null;

    const PaymentDialogCloned = PaymentDialog ? cloneElement(
        PaymentDialog,
        { open: paymentDialogOpen, onClose: closePaymentDialog, onSave: closePaymentDialogAndRefresh, ids: selected }
    ) : null;

    const RefundDialogCloned = RefundDialog ? cloneElement(
        RefundDialog,
        { open: refundDialogOpen, onClose: closeRefundDialog, onSave: closeRefundDialogAndRefresh, ids: selected }
    ) : null;

    return (
        <Toolbar
            className={classNames(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
            >
            <div className={classes.title}>
                {numSelected > 0 ? (
                    <Typography color="inherit" variant="subtitle1">
                        {numSelected} selected
                    </Typography>
                ) : (
                    <Typography variant="h6" id="table-title">
                        {label}
                    </Typography>
                )}
            </div>
            {numSelected == 0 &&
                <div className={classes.searchContainer}>
                    <div className={classes.search}>
                        <InputBase
                            value={searchValue}
                            placeholder={"Search…"}
                            classes={{
                                root: classes.inputRoot,
                                input: classes.inputInput,
                            }}
                            onChange={onSearchValueChange}
                            onKeyPress={handleSearch}
                            />
                        <Select
                            value={searchColumn}
                            onChange={onSearchColumnChange}
                            disableUnderline
                            >
                            {columns.map(row => (
                                <MenuItem key={row.id} value={row.id}>{row.label}</MenuItem>
                            ))}
                        </Select>
                    </div>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={event => handleSearch(event, true)}
                        >
                        Search
                    </Button>
                </div>
            }
            <div className={classes.spacer} />
            <div className={classes.actions}>
                {numSelected > 0 ? (
                    <div className={classes.searchContainer}>
                        {PaymentDialog &&
                            <Tooltip title="Mark Selected as Paid">
                                <IconButton aria-label="Refund Selected" onClick={openPaymentDialog}>
                                    <PaymentIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {RefundDialog &&
                            <Tooltip title="Refund Selected">
                                <IconButton aria-label="Refund Selected" onClick={openRefundDialog}>
                                    <RefundIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {EmailDialog &&
                            <Tooltip title="Email Campaigns">
                                <IconButton
                                    aria-label="Email Selected"
                                    onClick={openEmailDialog}
                                    >
                                    <EmailIcon/>
                                </IconButton>
                            </Tooltip>
                        }
                        <Tooltip title="Export Selected">
                            <IconButton aria-label="Export Selected" onClick={exportItems}>
                                <ExportIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <IconButton aria-label="Delete" onClick={deleteItems}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                ) : (
                    <div className={classes.searchContainer}>
                        {NewDialog &&
                            <Tooltip title="Add New">
                                <IconButton
                                    aria-label="Add New"
                                    onClick={openNewDialog}
                                    >
                                    <AddIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {newUrl &&
                            <Tooltip title="Add New">
                                <IconButton
                                    aria-label="Add New"
                                    component={Link}
                                    to={newUrl}
                                    >
                                    <AddIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {EmailDialog &&
                            <Tooltip title="Email Campaigns">
                                <IconButton
                                    aria-label="Email"
                                    onClick={openEmailDialog}
                                    >
                                    <EmailIcon/>
                                </IconButton>
                            </Tooltip>
                        }
                        {FilterDialog &&
                            <Tooltip title="Filter Data">
                                <IconButton
                                    aria-label="Filter"
                                    onClick={openFilterDialog}
                                    >
                                    <Badge badgeContent={filterCount} color="primary">
                                        <FilterIcon/>
                                    </Badge>
                                </IconButton>
                            </Tooltip>
                        }
                        {onImport &&
                            <Tooltip title="Import">
                                <IconButton aria-label="Import" onClick={onImport}>
                                    <ImportIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {onExportAll &&
                            <Tooltip title="Export All">
                                <IconButton aria-label="Export All" onClick={exportAll}>
                                    <ExportIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {onExportSelected &&
                            <Tooltip title="Show/Hide Columns" disableFocusListener>
                                <IconButton aria-label="Column List" onClick={openColumnsDialog}>
                                    <FilterListIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        <Tooltip title="Print Visible Rows">
                            <IconButton aria-label="Print Visible" onClick={print}>
                                <PrintIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Refresh Data">
                            <IconButton aria-label="Refresh Data" onClick={getTable}>
                                <RefreshIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                )}
            </div>
            <TableColumns
                open={columnsDialogOpen}
                onClose={closeColumnsDialog}
                columns={columns}
                viewableColumns={viewableColumns}
                onToggleColumn={onToggleColumn}
                onToggleAllColumns={onToggleAllColumns}
            />
            {FilterDialogCloned}
            {NewDialogCloned}
            {EmailDialogCloned}
            {PaymentDialogCloned}
            {RefundDialogCloned}
        </Toolbar>
    );
};
